import React, { useState, useEffect, useRef } from "react";
import { Modal, Form, Input, Button } from "antd";
import { BASE_URL, callApi } from "../../api/apiCaller";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";
import configureAppStore from "../../redux/store";

const AddVideo = ({ visible, toggleModal, recordData }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState(null); // Changed from icon to image
  const [fileError, setFileError] = useState("");
  const fileInputRef = useRef(null);
  const dummyImage =
    "https://novathreadbucket.s3.amazonaws.com/nova-app-1685176470232-dummy.PNG";

  useEffect(() => {
    if (visible) {
      if (recordData) {
        form.setFieldsValue({
          name: recordData?.name,
          email: recordData?.email,
          description: recordData?.description,
          instLink: recordData?.instLink,
          WhatsAppLink: recordData?.WhatsAppLink,
          LinkedInLink: recordData?.LinkedInLink,
        });
        setImage(recordData?.image || dummyImage); // Changed from icon to image
      } else {
        form.resetFields();
        setImage(dummyImage); // Changed from icon to image
      }
    }
  }, [visible, recordData, form]);

  const pickImageFile = () => {
    fileInputRef.current.click();
  };
  const token = configureAppStore.getState().userDataSlice.token;

  const uploadImageOnS3 = async (file) => {
    const myHeaders = new Headers();
    const formData = new FormData();
    formData.append("file", file);
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    return await new Promise((resolve, reject) => {
      fetch(`${BASE_URL}user/upload`, requestOptions)
        .then((response) => response.json())
        .then((result) => resolve(result?.url))
        .catch((error) => reject(error));
    });
  };

  const handleFileChange = async (event) => {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file = fileList[0];

      const validTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!validTypes.includes(file.type)) {
        setFileError("Please select a valid image file (jpg, jpeg, png).");
        return;
      }
      try {
        const imgUrl = await uploadImageOnS3(file);
        setImage(imgUrl); // Changed from setIcon to setImage
        setFileError("");
      } catch (error) {
        console.error("Error uploading image:", error);
        setFileError("An error occurred while uploading the image.");
      }
    } else {
      setFileError("Please select a file.");
    }
  };

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        const requestBody = {
          ...values,
          image: image, // Changed from icon to image
        };
        console.log("body", requestBody);

        const getRes = (res) => {
          console.log("Response got", res);
          if (res.status === 400) {
            if (
              res.message === "Trainer already exists, you can add only one."
            ) {
              RedNotify("A trainer already exists. You can only add one.");
              toggleModal();
            } else {
              RedNotify("Validation Error: " + res.message);
            }
          } else if (res.status === 200) {
            GreenNotify(
              recordData
                ? "Trainer updated successfully."
                : "Trainer created successfully."
            );
            toggleModal();
          } else {
            RedNotify("An error occurred. Please try again later.");
          }
        };

        const apiCall = recordData
          ? callApi(
              "PATCH",
              `${routes.updateTrainer}/${recordData._id}`,
              requestBody,
              setIsLoading,
              getRes
            )
          : callApi(
              "POST",
              `${routes.createTrainer}`,
              requestBody,
              setIsLoading,
              getRes
            );

        apiCall.catch((error) => {
          console.error("API call error", error);
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        });
      })
      .catch((errorInfo) => {
        console.error("Validation Error:", errorInfo);
        RedNotify("Please ensure all fields are filled out correctly.");
      });
  };

  return (
    <Modal
      title={recordData ? "Update Trainer" : "Create Trainer"}
      visible={visible}
      onCancel={toggleModal}
      footer={[
        <Button key="cancel" onClick={toggleModal}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          {recordData ? "Update" : "Save"}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[
            { required: true, message: "Please enter the name" },
            { min: 3, message: "Name must be at least 3 characters long" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Please enter the email" },
            { type: "email", message: "Please enter a valid email address" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="WhatsApp"
          name="WhatsAppLink"
          rules={[
            { required: true, message: "Please enter the WhatsApp Link" },
            { type: "url", message: "Please enter a valid URL" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Instagram"
          name="instLink"
          rules={[
            { required: true, message: "Please enter the Instagram Link" },
            { type: "url", message: "Please enter a valid URL" },
          ]}
        >
          <Input />
        </Form.Item>
        {/* <Form.Item
          label="LinkedIn"
          name="LinkedInLink"
          rules={[
            { required: true, message: "Please enter the LinkedIn Link" },
            { type: "url", message: "Please enter a valid URL" },
          ]}
        >
          <Input />
        </Form.Item> */}
        <Form.Item
          label="Description"
          name="description"
          rules={[
            { required: true, message: "Please enter the description" },
            {
              min: 10,
              message: "Description must be at least 10 characters long",
            },
          ]}
        >
          <Input.TextArea autoSize />
        </Form.Item>

        <div
          onClick={pickImageFile}
          style={{ marginBottom: "2rem" }}
          className="add-product-modal-input-title"
        >
          <h2>Image</h2>
          <div className="add-product-modal-image">
            <img
              src={image || dummyImage} // Changed from icon to image
              alt="Trainer image"
              style={{ width: "100px", height: "100px", margin: "0 5px" }}
            />
          </div>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          {fileError && <p style={{ color: "red" }}>{fileError}</p>}
        </div>
      </Form>
    </Modal>
  );
};

export default AddVideo;
